{
	"title": "Transaction introuvable",
	"description": "Veuillez revenir à l’aperçu et saisir un identifiant de transaction valide. Un identifiant de transaction se trouve sur une déclaration ou sur une facture.",
	"secondaryButtonTitle": "Afficher la page d’accueil"
}
